//#region src/slugify.ts
var SlugifyService = class {
	static convert = /* @__PURE__ */ new Map([
		["à", "a"],
		["â", "a"],
		["ä", "a"],
		["é", "e"],
		["è", "e"],
		["ê", "e"],
		["ë", "e"],
		["î", "i"],
		["ï", "i"],
		["í", "i"],
		["ô", "o"],
		["ö", "o"],
		["ò", "o"],
		["û", "u"],
		["ü", "u"],
		["ù", "u"],
		["ú", "u"],
		["ç", "c"],
		["œ", "oe"],
		["æ", "ae"],
		["ø", "o"]
	]);
	constructor() {}
	static apply(sentence) {
		const SLUG_SEPARATOR = "-";
		const newWordDelimiter = /* @__PURE__ */ new RegExp("[ '/?#&]+", "gm");
		const nonStandardChar = /* @__PURE__ */ new RegExp("[^A-Za-z0-9]", "gm");
		const startOrEndWithSeparator = new RegExp(`^[${SLUG_SEPARATOR}]+|[${SLUG_SEPARATOR}]+$`, "gm");
		return sentence.toLowerCase().normalize("NFC").replace(nonStandardChar, (char) => this.convert.get(char) ?? char).replace(newWordDelimiter, SLUG_SEPARATOR).replace(startOrEndWithSeparator, "");
	}
	static applyOnOptional(sentence) {
		return sentence ? this.apply(sentence) : void 0;
	}
};
//#endregion
export { SlugifyService };

//# sourceMappingURL=index.mjs.map